import React from "react";
import { useOutletContext } from "react-router-dom";
import { formatToZMW } from "../../../../helpers";

const Cashbooks = ({currentYearData, previousYearData, startDate}) =>{
    const {allData} = useOutletContext();
    const currentYear = startDate ? new Date(startDate).getFullYear() : new Date().getFullYear();
    const previousYear = currentYear - 1;

    return (
        <div>
            <hr className="border-t-2 border-slate-200 py-5" />
            <h1 className="text-2xl font-bold text-slate-800">Cash Balances</h1>
            <span>The Council had the following reconciled bank account balances as at the 31st December {currentYear}:</span>

            <table className="w-full table-auto border-collapse shadow-sm rounded-lg overflow-hidden mb-6">
                <thead className="bg-blue-950 text-white">
                    <tr>
                        <th className="px-4 py-3 text-left font-medium">Bank Name</th>
                        <th className="px-4 py-3 text-left font-medium">Account No</th>
                        <th className="px-4 py-3 text-right font-medium">{currentYear}</th>
                        <th className="px-4 py-3 text-right font-medium">{previousYear}</th>
                    </tr>
                </thead>

                <tbody className="bg-white">
                    {allData.bank?.map((bank) => {
                        // Calculate previous year balance
                        const previousYearIncome = previousYearData
                            ?.filter(item => item.bank === bank.id && item.type === 'income')
                            ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;
                        
                        const previousYearExpense = previousYearData
                            ?.filter(item => item.bank === bank.id && item.type === 'expense')
                            ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;
                        
                        const previousYearBalance = previousYearIncome - previousYearExpense;

                        // Calculate current year transactions
                        const currentYearIncome = currentYearData
                            ?.filter(item => item.bank === bank.id && item.type === 'income')
                            ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;
                        
                        const currentYearExpense = currentYearData
                            ?.filter(item => item.bank === bank.id && item.type === 'expense')
                            ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;

                        // Current year balance includes previous year balance
                        const currentYearBalance = previousYearBalance + currentYearIncome - currentYearExpense;

                        return (
                            <tr key={bank.id} className="odd:bg-gray-50">
                                <td className="px-4 py-3 text-slate-800 font-medium">{bank.name}</td>
                                <td className="px-4 py-3 text-slate-800">{bank.account_no}</td>
                                <td className="px-4 py-3 text-right font-medium text-slate-800">
                                    {formatToZMW(currentYearBalance)}
                                </td>
                                <td className="px-4 py-3 text-right font-medium text-slate-800">
                                    {formatToZMW(previousYearBalance)}
                                </td>
                            </tr>
                        );
                    })}
                    
                    {/* Totals Row */}
                    {(() => {
                        // Calculate totals across all banks
                        const totalCurrentYear = allData.bank?.reduce((total, bank) => {
                            const previousYearIncome = previousYearData
                                ?.filter(item => item.bank === bank.id && item.type === 'income')
                                ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;
                            
                            const previousYearExpense = previousYearData
                                ?.filter(item => item.bank === bank.id && item.type === 'expense')
                                ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;
                            
                            const previousYearBalance = previousYearIncome - previousYearExpense;

                            const currentYearIncome = currentYearData
                                ?.filter(item => item.bank === bank.id && item.type === 'income')
                                ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;
                            
                            const currentYearExpense = currentYearData
                                ?.filter(item => item.bank === bank.id && item.type === 'expense')
                                ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;

                            const currentYearBalance = previousYearBalance + currentYearIncome - currentYearExpense;
                            
                            return total + currentYearBalance;
                        }, 0) || 0;

                        const totalPreviousYear = allData.bank?.reduce((total, bank) => {
                            const previousYearIncome = previousYearData
                                ?.filter(item => item.bank === bank.id && item.type === 'income')
                                ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;
                            
                            const previousYearExpense = previousYearData
                                ?.filter(item => item.bank === bank.id && item.type === 'expense')
                                ?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || 0;
                            
                            const previousYearBalance = previousYearIncome - previousYearExpense;
                            
                            return total + previousYearBalance;
                        }, 0) || 0;

                        return (
                            <tr className="bg-blue-950 text-white font-bold">
                                <td className="px-4 py-3 font-bold">TOTAL</td>
                                <td className="px-4 py-3"></td>
                                <td className="px-4 py-3 text-right font-bold">
                                    {formatToZMW(totalCurrentYear)}
                                </td>
                                <td className="px-4 py-3 text-right font-bold">
                                    {formatToZMW(totalPreviousYear)}
                                </td>
                            </tr>
                        );
                    })()}
                </tbody>
            </table>
        </div>
    );
}

export default Cashbooks;